import {
  CollectionActions,
  CollectionStateSlice,
  mergeDocuments,
  mergeWebsocketDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformEnterprise } from '../enterprises/enterprises.transformers';
import { AdminEnterprisesCollection } from './admin-enterprises.types';

export function adminEnterprisesReducer(
  state: CollectionStateSlice<AdminEnterprisesCollection> = {},
  action: CollectionActions<AdminEnterprisesCollection>,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'adminEnterprises') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<AdminEnterprisesCollection>(
          state,
          transformIntoDocuments(result.enterprises, transformEnterprise),
          order,
          ref,
        );
      }
      return state;
    }
    case 'API_PUSH_SUCCESS': {
      if (action.payload.type === 'adminEnterprises') {
        const { result, ref } = action.payload;
        return mergeWebsocketDocuments<AdminEnterprisesCollection>(
          state,
          transformIntoDocuments([result.enterprise], transformEnterprise),
          ref,
        );
      }
      return state;
    }
    default:
      return state;
  }
}
